import { createSlice } from "@reduxjs/toolkit";

export const ClientWhiseTokenByAccountTypeSlice = createSlice({
    name: "clientWhiseTokenByAccountType",
    initialState: {
        clientWhiseTokenByAccountType: "",
    },
    reducers: {
        setClientWhiseTokenByAccountType: (state, action) => {
            state.clientWhiseTokenByAccountType = action.payload;
        },
    }
})

export const { setClientWhiseTokenByAccountType } = ClientWhiseTokenByAccountTypeSlice.actions;

export default ClientWhiseTokenByAccountTypeSlice.reducer;